import React from "react";
import "../../Assets/SCSS/components/Thumbnail.scss";

const ProfilePictureMedium = ({ src }) => <img className="profile-picture-medium" src={src}></img>;

export default ProfilePictureMedium;
